import React, { useState, useEffect } from 'react';
import { IoSearch } from 'react-icons/io5';
import './css/ManageLicences.css';
import UsersList from './UsersList';
import Navbar from '../lab/Navbar';
import labService from '../lab/labService';

const ManageLicences = () => {
  const [filterValue, setFilterValue] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const userData = JSON.parse(localStorage.getItem('user'));

      if (!userData || !userData.access) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await labService.getUsersList(userData.access);
        const mappedUsers = response.data.map(user => ({
          id: user.id,
          companyName: user.company || '-',
          companyAddress: user.company_adress || '-',
          organizationNumber: user.nip_vat || '-',
          email: user.email,
          createdDate: new Date().toISOString(),
          hasActiveLicense: user.coins > 0,
          isActive: user.is_active
        }));

        setUsers(mappedUsers);
      } catch (error) {
        console.error('Błąd podczas pobierania listy użytkowników:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleSearchChange = (event) => {
    setFilterValue(event.target.value);
  };

  const filteredUsers = users.filter(user =>
    user.email.toLowerCase().includes(filterValue.toLowerCase())
  );

  return (
    <div className='lab-container'>
      <Navbar />

      <div className="manage-licenses-container">
        <header className="manage-licenses-header">
          <h2 className='h2-title'>Manage Licenses</h2>
        </header>

        <div className="search-section">
          <div className="search-input-wrapper">
            <IoSearch className="search-icon" />
            <input
              type="email"
              placeholder="Search by E-mail"
              value={filterValue}
              onChange={handleSearchChange}
              className="search-input"
            />
          </div>
        </div>

        {isLoading ? (
          <div className="loading-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <UsersList
            data={filteredUsers}
            hasMore={false}
            getMoreData={() => console.log('Pobierz więcej')}
          />
        )}
      </div>
    </div>
  );
};

export default ManageLicences;
